import { InjectionToken } from '@angular/core';
import { environment } from '../../../environments/environment.local';

export const RECAPTCHA_V3_SITE_KEY = new InjectionToken<string>(environment.recaptchaKey);
